export default __webpack_public_path__ + "static/media/Monk's Harness of the Spilling Blood.c459a0ce.jpg";